
import React from 'react'

import { MasterModal, ModalHistory } from '../../components'

const ProgressHistory = (props) => {
  const { data, isProgress, progressItem } = props

  return (
    <div style={{ maxWidth: '40vw' }}>
      <MasterModal
        step={props.data ? props.data.Sr_Status : ''}
        width={45}
        maxWidth='lg'
        isStatic={true}
        isSrModal={true}
        fullWidth={true}
        isProgress={isProgress}
        title='Detail Status Progress'
        showModal={props.showModal}
        handleClose={() => props.closeSrModal(!props.showModal)}
      >
        <div style={{ background: '#F6F9FC', height : '47rem', overflowY : 'auto' }}>
          <ModalHistory
            data={data}
            progressItem={progressItem}
          />
        </div>
      </MasterModal>
    </div>
  )
}
export default ProgressHistory